import React, { useState } from 'react'
import PropTypes from 'prop-types'
import defaultShowPic from '../../asset/start-page-show-pic.png'
import {
  CardContainer,
  ImgWrapper,
  Img,
  CardContentWrapper,
  CardTitle,
  CardText,
  RadioButtonWrapper,
  RadioButton,
} from './style'

const ImageCard = ({ title, content, haveButtons, showPic }) => {
  const [checkedButton, setChecked] = useState({
    first: true,
    second: false,
    third: false,
  })
  function selectFeature(index) {
    if (index === 1) {
      setChecked({ first: true, second: false, third: false })
    } else if (index === 2) {
      setChecked({ first: false, second: true, third: false })
    } else {
      setChecked({ first: false, second: false, third: true })
    }
  }
  return (
    <CardContainer>
      <ImgWrapper haveButtons={haveButtons}>
        <Img src={showPic ? showPic : defaultShowPic} role="image" alt=""></Img>
      </ImgWrapper>
      <CardContentWrapper>
        {title && <CardTitle>{title}</CardTitle>}
        {content && <CardText>{content}</CardText>}
        {haveButtons && (
          <RadioButtonWrapper>
            <RadioButton
              type="radio"
              name="feature-1"
              value=""
              checked={checkedButton.first}
              onClick={() => selectFeature(1)}
            ></RadioButton>
            <RadioButton
              type="radio"
              name="feature-2"
              value=""
              checked={checkedButton.second}
              onClick={() => selectFeature(2)}
            ></RadioButton>
            <RadioButton
              type="radio"
              name="feature-3"
              value=""
              checked={checkedButton.third}
              onClick={() => selectFeature(3)}
            ></RadioButton>
          </RadioButtonWrapper>
        )}
      </CardContentWrapper>
    </CardContainer>
  )
}
ImageCard.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  haveButtons: PropTypes.bool,
  showPic: PropTypes.string,
}

export default ImageCard
